import { inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";

import { catchError, from, map, of, switchMap } from "rxjs";

import { quickJsActions } from "./quickjs.actions";
import { QuickJsService } from "./quickjs.service";

export const reloadScript = createEffect((
  actions$ = inject(Actions),
  quickJs = inject(QuickJsService),
) => {
    return actions$.pipe(
      ofType(quickJsActions.fetchScriptSuccess),
      switchMap(({ script }) => from(quickJs.loadScript(script)).pipe(
        map(() => quickJsActions.loadScriptSuccess()),
        catchError((error) => of(quickJsActions.loadScriptError({ error }))),
      )),
    );
}, { functional: true, dispatch: true });


export const unloadScript = createEffect((
  actions$ = inject(Actions),
  quickJs = inject(QuickJsService),
) => {
    return actions$.pipe(
      ofType(quickJsActions.fetchScriptError),
      switchMap(() => from(quickJs.unloadScript()).pipe(
        map(() => quickJsActions.unloadScriptSuccess()),
        catchError((error) => of(quickJsActions.unloadScriptError({ error }))),
      )),
    );
}, { functional: true, dispatch: true });
